<template>
    <div>
        <compras-diretas-abertas-titulo-secao titulo="Sugestões baseado nas suas linhas de fornecimento"/>

        <az-container>
            <az-form>
                <div class="carrossel-caixa-branca">
                    <div class="area-conteudo">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="compra in value" :key="compra.id">
                                    <compras-diretas-meu-interesse-carrossel-card :compra="compra"
                                                                                @tratarEventoAcessar="tratarEventoAcessar(compra)"/>
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>
                    </div>
                </div>
                <div class="az-pagination" v-if="paginas > 1 || totalItens > 0">
                    <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
                    <div class="az-select-pagination">
                        <span>Linhas por página:</span>
                        <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                    </div>
                </div>
            </az-form>
        </az-container>
    </div>
</template>

<script>
import ComprasDiretasAbertasTituloSecao from './ComprasDiretasAbertasTituloSecao'
import Swiper from 'swiper/js/swiper'
import 'swiper/css/swiper.min.css'
import ComprasDiretasMeuInteresseCarrosselCard from '@/views/pages/fornecedor/compras-diretas-abertas/ComprasDiretasMeuInteresseCarrosselCard'

export default {
    name: 'ComprasDiretasMeuInteresseCarrossel',
    components: {
        ComprasDiretasAbertasTituloSecao,
        ComprasDiretasMeuInteresseCarrosselCard
    },
    props: {
        value: {
            required: true,
            type: Array,
            default: () => []
        },
        paginas: {
            type: Number,
            default: 0
        },
        paginacao: {
            type: Object,
            default: () => ({ page: 1, rowsPerPage: 10, descending: true, sortBy: 'dataHoraInicioEnvioPropostas' })
        },
        totalItens: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            swiper: null,
            linhasPorPagina: [10, 25, 50, 100],
            paginacaoInterna: this.paginacao
        }
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true
        },
        value() {
            if (this.swiper) {
                this.$nextTick(() => {
                    this.swiper.update && this.swiper.update()
                })
            }
        }
    },
    mounted() {
        if (this.value.length > 0) {
            this.swiper = new Swiper('.swiper-container', {
                loop: false,
                autoHeight: true,
                slidesPerView: 1,
                a11y: true,
                keyboardControl: true,
                spaceBetween: 10,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1240: {
                        slidesPerView: 4,
                        spaceBetween: 20
                    },
                    1640: {
                        slidesPerView: 7,
                        spaceBetween: 20
                    }
                }
            })
        }
    },
    methods: {
        tratarEventoAcessar(compra) {
            this.$router.push({
                name: 'DetalhesCompraDireta',
                params: {
                    id: compra.id
                }
            })
        },
    }
}
</script>

<style scoped lang="stylus">
    .area-conteudo
        position relative
        padding 0
        margin 5px 0 0

    .swiper-container
        height auto
        padding 0 20px
        box-shadow none
        width 100%

    .swiper-wrapper
        padding 0
        margin-bottom 30px

    .swiper-slide
        height auto
        font-size 14px
        background-color #ffffff
        display flex
        align-items stretch
        justify-content flex-start
        padding 16px
        box-sizing border-box
        transition all .25s ease
        box-shadow 0 2px 8px rgba(0, 0, 0, 0.05)
        border 1px solid #e6e9ee
        border-radius 12px

    .swiper-slide:hover
        box-shadow 0 8px 24px rgba(0, 0, 0, 0.08)
        transform translateY(-4px)
        border-color #d0d7e2
        cursor pointer

    .titulo-carrosel
        padding 10px 40px 0
        color var(--v-primary--text) !important
        font-weight bold
        font-size 16px

    .carrossel-caixa-branca
        background-color white
        padding 10px 0
        border-radius 4px

    .swiper-pagination-bullet
        width 20px
        height 20px
        text-align center
        line-height 20px
        font-size 12px
        color #000
        opacity 1
        background-color rgba(0, 0, 0, .2)

    .swiper-container-horizontal > .swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction
        bottom 0
</style>
